const MainButton = ({
    children,
    onClick,
    className = "",
    type = "button",
    disabled = false,
}) => {
    return (
        <button
            disabled={disabled}
            type={type}
            onClick={onClick}
            className={`
        px-4 py-2 text-sm md:text-base font-semibold rounded-xl
        dark:bg-primary bg-primary-light
        dark:text-bg-dark-primary text-bg-light-primary
        duration-300 shadow-glow
        hover:opacity-90 hover:shadow-glow-hover

        disabled:opacity-50
        disabled:cursor-not-allowed
        disabled:hover:opacity-50
        disabled:hover:shadow-none

        ${className}
      `}
        >
            {children}
        </button>
    );
};

export default MainButton;
